import { PersonStatusEnum } from "../types/Api";
import { RoleEnum } from "../types/RoleEnum";
import { hasRole } from "./permissionsUtils";
// Order shown in the register filter: "Potvrzeno" (osoby z autorit) first, then "Návrh"
// (návrhy nakladatelů), then "Bez shody v autoritách" (SEARCH_FAILED) as an extra opt-in choice.
// SEARCH_FAILED marks a proposal for which the nightly sync found similar NK ČR authority records
// but none matching unambiguously; only agency staff can act on it, so it is offered to them only.
export var personFilterStatuses = [
    PersonStatusEnum.CONFIRMED,
    PersonStatusEnum.PROPOSAL,
    PersonStatusEnum.SEARCH_FAILED,
];
// Default register view has "Potvrzeno" and "Návrh" checked; SEARCH_FAILED is hidden until
// the user opts in. Kept as a shared constant so both person filter hooks seed the same default.
export var DEFAULT_PERSON_FILTER_STATUSES = [
    PersonStatusEnum.CONFIRMED,
    PersonStatusEnum.PROPOSAL,
];
// The SEARCH_FAILED option is reserved for agency workers (hasRole also lets a superuser through).
export var canSeeSearchFailedStatus = function (activeRoles) { return !!activeRoles && !!hasRole(activeRoles, RoleEnum.AGENCY_WORKER); };
// Status options of the register filter the current user may choose from.
export var getPersonFilterStatuses = function (canSeeSearchFailed) {
    return canSeeSearchFailed
        ? personFilterStatuses
        : personFilterStatuses.filter(function (status) { return status !== PersonStatusEnum.SEARCH_FAILED; });
};
// Drops SEARCH_FAILED (e.g. from a shared URL) for a user who may not filter by it. An emptied
// selection falls back to the default view, never to "all statuses".
export var sanitizePersonFilterStatuses = function (statuses, canSeeSearchFailed) {
    if (canSeeSearchFailed)
        return statuses;
    var allowed = statuses.filter(function (status) { return status !== PersonStatusEnum.SEARCH_FAILED; });
    if (allowed.length === statuses.length)
        return statuses;
    return allowed.length > 0 ? allowed : DEFAULT_PERSON_FILTER_STATUSES;
};
